import { ColProps, Form, Input } from "antd";
import { ReactNode } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  label: ReactNode;
  placeholder: string;
  errorMessage?: string;
  control: Control<TSchema>;
  className?: string;
  labelCol?: ColProps | undefined;
  wrapperCol?: ColProps | undefined;
  disabled?: boolean;
  isVertical?: boolean;
}

export default function FieldInput<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const {
    name,
    label,
    placeholder,
    errorMessage,
    control,
    labelCol,
    wrapperCol,
    disabled,
    isVertical,
  } = props;

  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      label={label}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      layout={isVertical ? "vertical" : "horizontal"}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Input
            {...field}
            // {...additionnal}
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
      />
    </Form.Item>
  );
}
